module.exports = "https://r.nearpod.com/assets/media/image/mp-icon-white-bc472334730ae82c6b4059dad356fa89.svg";